<template>
    <NotificationGroup group="main">
        <div
            class="fixed inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none z-50"
        >
            <div class="w-full max-w-sm">
                <Notification
                    v-slot="{ notifications }"
                    enter="transform ease-out duration-300 transition"
                    enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
                    enter-to="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-500"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                    move="transition duration-500"
                    move-delay="delay-300"
                >
                    <div
                        class="flex w-full max-w-sm mx-auto mt-4 overflow-hidden bg-white rounded-lg shadow-md"
                        v-for="notification in notifications"
                        :key="notification.id"
                    >
                        <div class="flex items-center justify-center w-12 bg-green-500">
                            <check-circle-icon class="w-6 h-6 text-white"></check-circle-icon>
                        </div>

                        <div class="px-4 py-2 -mx-3">
                            <div class="mx-3">
                                <span class="font-semibold text-green-500">{{ $t(notification.title) }}</span>
                                <p class="text-sm text-gray-600">{{ $t(notification.text) }}</p>
                            </div>
                        </div>
                    </div>
                </Notification>
            </div>
        </div>
    </NotificationGroup>

</template>

<script>
import { CheckCircleIcon } from "@heroicons/vue/24/outline";

export default {
    name: "Toast",
    props: ["group"],
    components: {
        CheckCircleIcon
    },
    computed: {
        pageFlashes() {
            return this.$page.props.flash;
        },
    },
    watch: {
        pageFlashes: {
            handler(flash){
                if(!flash){
                    return;
                }
                this.$notify({
                    group: "main",
                    title:flash.title,
                    text: flash.message
                }, 2000);

            }
        }
    }

};
</script>

<style scoped>

</style>
